var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHeadset = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M445.244 388.744a7.499 7.499 0 00-7.5 7.5v39.742c0 25.696-20.947 46.602-46.695 46.602h-79.191c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h79.191c34.019 0 61.695-27.635 61.695-61.602v-39.742a7.5 7.5 0 00-7.5-7.5z",
  fill: "#dbe9ee",
  "data-original": "#ffcf48"
}), /*#__PURE__*/React.createElement("path", {
  d: "M443.132 187.693v72.78l-44.91-15.003v-57.777c0-81.22-66.77-145.84-147.481-142.57-75.49 3.05-135.961 65.83-135.961 142.57v72.78H69.86v-72.78c0-106.88 87.04-191.37 193.361-187.57 99.811 3.57 179.911 86.34 179.911 187.57z",
  fill: "#dbe9ee",
  "data-original": "#ffe85f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.86 187.693h44.92v72.78H69.86zM443.132 187.693v72.78l-44.91-15.003v-57.777z",
  fill: "#dbe9ee",
  "data-original": "#ffcf48"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512 325.36c0 10.86-3.44 21.13-9.44 29.58-6 8.44-14.57 15.06-24.83 18.63l-10.21 3.55-3.52 1.22c-.8.28-1.62.41-2.44.41-2.46 0-4.88-1.22-6.34-3.54-.77-1.22-1.1-2.66-1.1-4.1v-91.5c0-1.44.33-2.89 1.1-4.1 1.96-3.08 5.6-4.23 8.78-3.12l3.53 1.23 10.2 3.54c20.52 7.13 34.27 26.48 34.27 48.2z",
  fill: "#febc42",
  "data-original": "#616270"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512 325.36c0 10.86-3.44 21.13-9.44 29.58-6 8.44-14.57 15.06-24.83 18.63l-10.21 3.55c14.41-12.6 23.51-31.12 23.51-51.76s-9.1-39.15-23.5-51.74l10.2 3.54c20.52 7.13 34.27 26.48 34.27 48.2z",
  fill: "#febc42",
  "data-original": "#40414c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M468.09 268.92v112.11c0 12.95-10.48 23.44-23.4 23.44h-68.41v-159h68.41c12.92 0 23.4 10.5 23.4 23.45z",
  fill: "#6cbbed",
  "data-original": "#51e08b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M468.09 268.92v112.11c0 12.95-10.48 23.44-23.4 23.44h-24c12.92 0 23.4-10.49 23.4-23.44V268.92c0-12.95-10.48-23.45-23.4-23.45h24c12.92 0 23.4 10.5 23.4 23.45z",
  fill: "#6cbbed",
  "data-original": "#1bc18a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 325.364c0 10.86 3.44 21.13 9.44 29.58 6 8.44 14.57 15.06 24.83 18.63l10.21 3.55 3.52 1.22c.8.28 1.62.41 2.44.41 2.46 0 4.88-1.22 6.34-3.54.77-1.22 1.1-2.66 1.1-4.1v-91.5c0-1.44-.33-2.89-1.1-4.1-1.96-3.08-5.6-4.23-8.78-3.12l-3.53 1.23-10.2 3.54C13.75 284.294 0 303.644 0 325.364z",
  fill: "#febc42",
  "data-original": "#616270"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 325.364c0 10.86 3.44 21.13 9.44 29.58 6 8.44 14.57 15.06 24.83 18.63l10.21 3.55c-14.41-12.6-23.51-31.12-23.51-51.76s9.1-39.15 23.5-51.74l-10.2 3.54C13.75 284.294 0 303.644 0 325.364z",
  fill: "#febc42",
  "data-original": "#40414c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.913 268.919v112.109c0 12.948 10.476 23.445 23.4 23.445h68.404v-159H68.312c-12.923 0-23.399 10.497-23.399 23.446z",
  fill: "#6cbbed",
  "data-original": "#51e08b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.912 268.923v112.11c0 12.95 10.48 23.44 23.4 23.44h24c-12.92 0-23.4-10.49-23.4-23.44v-112.11c0-12.95 10.48-23.45 23.4-23.45h-24c-12.92 0-23.4 10.5-23.4 23.45z",
  fill: "#6cbbed",
  "data-original": "#1bc18a"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M316.859 490.05c0 12.14-9.82 21.95-21.88 21.95h-77.96c-12.06 0-21.87-9.81-21.87-21.88v-.07c0-12.06 9.81-21.87 21.87-21.87h77.96c12.06 0 21.88 9.81 21.88 21.87z",
  fill: "#febc42",
  "data-original": "#616270"
}), /*#__PURE__*/React.createElement("path", {
  d: "M316.859 490.05c0 12.14-9.82 21.95-21.88 21.95h-77.96c-12.06 0-21.87-9.81-21.87-21.88h77.95c12.07 0 21.88-9.81 21.88-21.94 12.06 0 21.88 9.81 21.88 21.87z",
  fill: "#febc42",
  "data-original": "#40414c"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M398.219 245.47v159c0 12.08-9.85 21.91-21.94 21.91-3.99 0-7.74-1.07-10.97-2.95-6.56-3.78-10.98-10.87-10.98-18.96v-159c0-8.09 4.42-15.18 10.98-18.96 3.23-1.88 6.98-2.95 10.97-2.95 12.09 0 21.94 9.83 21.94 21.91z",
  fill: "#febc42",
  "data-original": "#616270"
}), /*#__PURE__*/React.createElement("path", {
  d: "M398.219 245.47v159c0 12.08-9.85 21.91-21.94 21.91-3.99 0-7.74-1.07-10.97-2.95 6.55-3.79 10.97-10.87 10.97-18.96v-159c0-8.09-4.42-15.17-10.97-18.96 3.23-1.88 6.98-2.95 10.97-2.95 12.09 0 21.94 9.83 21.94 21.91z",
  fill: "#febc42",
  "data-original": "#40414c"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M114.776 245.47v159c0 12.08 9.85 21.91 21.94 21.91 3.99 0 7.74-1.07 10.97-2.95 6.56-3.78 10.98-10.87 10.98-18.96v-159c0-8.09-4.42-15.18-10.98-18.96a21.742 21.742 0 00-10.97-2.95c-12.09 0-21.94 9.83-21.94 21.91z",
  fill: "#febc42",
  "data-original": "#616270"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.776 245.47v159c0 12.08 9.85 21.91 21.94 21.91 3.99 0 7.74-1.07 10.97-2.95-6.55-3.79-10.97-10.87-10.97-18.96v-159c0-8.09 4.42-15.17 10.97-18.96a21.742 21.742 0 00-10.97-2.95c-12.09 0-21.94 9.83-21.94 21.91z",
  fill: "#febc42",
  "data-original": "#40414c"
})))));
export default SvgHeadset;